import * as React from "react";
import Analytics from "../components/Analytics";
import InnerPage from "../components/InnerPage";

export default function AnalyticsScreen() {
  return (
    <InnerPage title="Analytics">
      <Analytics />
    </InnerPage>
  );
}
